import { NgModule } from '@angular/core';

import { GravatarModule } from 'ngx-gravatar';

import { MainMenuComponent, SearchComponent as LayoutSearchComponent, UserProfileComponent } from '@bn/layout';
import { SubMenuComponent } from '@bn/layout/submenu';
import { FeatureFlagDirective, MixpanelEventsDirective, UserPermissionsDirective } from '@bn/shared/directives';

import {
  AddMenuComponent,
  BillingOverviewComponent,
  DashboardLayoutComponent,
  NotificationsComponent,
  SearchComponent,
  SidebarComponent,
  SupportComponent,
  SurveyWidgetComponent,
  UpdateNotificationComponent,
} from './components';

@NgModule({
  imports: [
    FeatureFlagDirective,
    UserPermissionsDirective,
    BillingOverviewComponent,
    GravatarModule,
    LayoutSearchComponent,
    MainMenuComponent,
    MixpanelEventsDirective,
    SubMenuComponent,
    UserProfileComponent,
    UpdateNotificationComponent,
    SurveyWidgetComponent,
    AddMenuComponent,
    DashboardLayoutComponent,
    NotificationsComponent,
    SearchComponent,
    SidebarComponent,
    SupportComponent,
    AddMenuComponent,
  ],
  providers: [MixpanelEventsDirective],
  exports: [
    FeatureFlagDirective,
    UserPermissionsDirective,
    AddMenuComponent,
    BillingOverviewComponent,
    DashboardLayoutComponent,
    MainMenuComponent,
    NotificationsComponent,
    SearchComponent,
    SubMenuComponent,
    SidebarComponent,
    SupportComponent,
    UserProfileComponent,
  ],
})
export class LayoutModule {}
